import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import LoadingDots from './LoadingDots';
/**
 * ChatWindow 组件：展示聊天消息，
 * 系统消息（user==='Nvoice'）左对齐，用户消息右对齐；
 * 显示头像和分钟级时间戳，不显示用户名
 */
export default function ChatWindow({ aiChatMessages }) {
  const containerRef = useRef(null);

  // 自动滚动到底部
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [aiChatMessages]);

  return (
    <div
      ref={containerRef}
      style={{
        display: 'flex',
        flexDirection: 'column',
        // height: '400px',
        overflowY: 'auto',
        padding: '1rem',
        // border: '1px solid #ddd',
        // borderRadius: '8px',
        // backgroundColor: '#fafafa'
        width: '100%',
      }}
    >
      {aiChatMessages.map(({ id, user, avatar, content, timestamp }) => {
        const isSystem = user === 'Nvoice';
        const timeText = new Date(timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        return (
          <div
            key={id}
            style={{
              display: 'flex',
              flexDirection: isSystem ? 'row' : 'row-reverse',
              alignItems: 'center',
              marginBottom: '0.75rem',
              width: '100%'
            }}
          >
            {/* 头像 */}
            {avatar && (
              <img
                src={avatar}
                alt="avatar"
                style={{
                  width: '32px',
                  height: '32px',
                  borderRadius: '50%',
                  margin: '0 0.5rem'
                }}
              />
            )}
            {/* 消息泡泡 */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: isSystem ? 'flex-start' : 'flex-end', maxWidth: '70%' }}>
              <div
                style={{
                  padding: '0.5rem',
                  borderRadius: '8px',
                  backgroundColor: isSystem ? '#ffffff' : '#dcf8c6',
                  textAlign: 'left'
                }}
              >
                {/* {content} */}
                {content === 'Session starting' ? (
                    <div>{content}<LoadingDots /></div>
                ) : (
                <div>{content}</div>
                )}
              </div>
              {/* <span style={{ fontSize: '0.75rem', color: '#999', marginTop: '0.25rem' }}>
                {timeText}
              </span> */}
            </div>
          </div>
        );
      })}
    </div>
  );
}

ChatWindow.propTypes = {
  aiChatMessages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      user: PropTypes.string.isRequired,
      avatar: PropTypes.string,
      content: PropTypes.string.isRequired,
      timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    })
  ).isRequired
};
